import i18next from 'i18next';
import { upperCaseBegin } from './stringUtils';
import { ApryseSDK } from '../pdf/ApryseSDK';
import type { Core } from '@pdftron/webviewer';

// /**
//  * Returns translation from i18next.
//  * If there is none, the fallback string is returned.
//  */
// export function translateOrDefault(key: string, fallback: string) {
//     const translation = i18next.t(key);
//     return translation === key ? fallback : translation;
// }

export function translateLineStyle(lineStyleName: string) {
    return i18next.t(`lineStyles.${lineStyleName.replaceAll(' ', '')}`);
}

export function translatePrettyType(annotation: Core.Annotations.Annotation): string {
    return i18next.t(
        `sidebar.annotationType.create${upperCaseBegin(ApryseSDK.annotPrettyType(annotation))}`,
    );
}
